import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

// components
import MenuTitle from "./MenuTitle";
import MenuItems from "./MenuItems";

const AuthMenuStyled = styled.nav`
    text-align: left;
`;

// component
export const AuthMenu = ({ menu, id = "auth-menu" }) => {
    const { name, links } = menu;

    return (
        <AuthMenuStyled data-testid={id} aria-labelledby={id}>
            <MenuTitle title={name} id={id} />
            <MenuItems links={links} />
        </AuthMenuStyled>
    );
};

export default AuthMenu;

// prop-types
AuthMenu.propTypes = {
    menu: PropTypes.object.isRequired,
    id: PropTypes.string
};
